/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OrgSelect_organization$ref: FragmentReference;
declare export opaque type OrgSelect_organization$fragmentType: OrgSelect_organization$ref;
export type OrgSelect_organization = {|
  +databaseId: string,
  +name: string,
  +iconUrl: any,
  +resourcePath: any,
  +$refType: OrgSelect_organization$ref,
|};
export type OrgSelect_organization$data = OrgSelect_organization;
export type OrgSelect_organization$key = {
  +$data?: OrgSelect_organization$data,
  +$fragmentRefs: OrgSelect_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgSelect_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourcePath",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '31e6eb0829ee038a076836582acc03a7';

module.exports = node;
